import React from 'react'
import {style} from 'glamor'

export default ({children, ...props}) => (
  <div
    {...props}
    {...style({
      width: '100%'
    })}
  >
    {children}
  </div>
)



/** WEBPACK FOOTER **
 ** ./src/components/pages/Page.js
 **/